import { SITE_URL } from '@/lib/structuredData';

export const LOCALES = {
  us: { cc: 'us', hreflang: 'en-US', og: 'en_US', lang: 'en', label: 'United States', country: 'United States', inCountry: 'the United States', seg: 'services', privacy: 'privacy-policy', privacyLabel: 'Privacy Policy' },
  ca: { cc: 'ca', hreflang: 'en-CA', og: 'en_CA', lang: 'en', label: 'Canada', country: 'Canada', inCountry: 'Canada', seg: 'services', privacy: 'privacy-policy', privacyLabel: 'Privacy Policy' },
  au: { cc: 'au', hreflang: 'en-AU', og: 'en_AU', lang: 'en', label: 'Australia', country: 'Australia', inCountry: 'Australia', seg: 'services', privacy: 'privacy-policy', privacyLabel: 'Privacy Policy' },
  es: { cc: 'es', hreflang: 'es-ES', og: 'es_ES', lang: 'es', label: 'España', country: 'Spain', inCountry: 'España', seg: 'servicios', privacy: 'politica-de-privacidad', privacyLabel: 'Política de privacidad' },
  mx: { cc: 'mx', hreflang: 'es-MX', og: 'es_MX', lang: 'es', label: 'México', country: 'Mexico', inCountry: 'México', seg: 'servicios', privacy: 'aviso-de-privacidad', privacyLabel: 'Aviso de privacidad' }
};

// Country sections that are published. Add a code here once its content file exists.
export const LIVE_LOCALES = ['us', 'ca', 'au', 'es', 'mx'];

export const SERVICE_KEYS = ['ai', 'automation', 'security', 'web'];

export const SERVICE_SLUGS = {
  en: { ai: 'custom-ai-development', automation: 'business-process-automation', security: 'ai-cybersecurity', web: 'web-and-saas-development' },
  es: { ai: 'desarrollo-de-ia-a-medida', automation: 'automatizacion-de-procesos', security: 'ciberseguridad-con-ia', web: 'desarrollo-web-y-saas' }
};

export const AE_SERVICE_PATHS = {
  ai: '/services/custom-ai-solutions-dubai',
  automation: '/services/business-automation-dubai',
  security: '/services/cybersecurity-ai-uae',
  web: '/services/website-development-dubai'
};

export const hubPath = (cc) => `/${cc}`;
export const servicePath = (cc, key) => `/${cc}/${LOCALES[cc].seg}/${SERVICE_SLUGS[LOCALES[cc].lang][key]}`;
export const privacyPath = (cc) => `/${cc}/${LOCALES[cc].privacy}`;
export const serviceKeyFromSlug = (cc, slug) =>
  SERVICE_KEYS.find((k) => SERVICE_SLUGS[LOCALES[cc].lang][k] === slug);
export const localeFromPath = (pathname) => {
  const cc = pathname.split('/')[1];
  return LIVE_LOCALES.includes(cc) ? LOCALES[cc] : null;
};

const abs = (p) => `${SITE_URL}${p}`;

export const homeAlternates = () => [
  { hreflang: 'x-default', href: abs('/') },
  { hreflang: 'en', href: abs('/') },
  ...LIVE_LOCALES.map((cc) => ({ hreflang: LOCALES[cc].hreflang, href: abs(hubPath(cc)) }))
];

export const serviceAlternates = (key) => [
  { hreflang: 'x-default', href: abs(AE_SERVICE_PATHS[key]) },
  { hreflang: 'en-AE', href: abs(AE_SERVICE_PATHS[key]) },
  ...LIVE_LOCALES.map((cc) => ({ hreflang: LOCALES[cc].hreflang, href: abs(servicePath(cc, key)) }))
];

export const ogAlternatesFor = (og) =>
  LIVE_LOCALES.map((cc) => LOCALES[cc].og).filter((o) => o !== og);

export const selectorOptions = () => [
  { label: 'Global / UAE', to: '/', cc: '' },
  ...LIVE_LOCALES.map((cc) => ({ label: LOCALES[cc].label, to: hubPath(cc), cc }))
];